import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelect from '@nxsys/components/AppSelect';
import { useGetListApprover } from '@nxsys/hooks/api/dashboard';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React, { useEffect, useMemo, useState } from 'react';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: RequestApprovalValues) => Promise<void>;
  defaultValues?: Partial<RequestApprovalValues>;
  payrollId: string;
};

export type RequestApprovalValues = {
  approverIds: Option<string>[];
};

const RequestApprovalModal: React.FC<Props> = ({
  isOpen,
  toggle,
  onSubmit,
  defaultValues = {},
  payrollId,
}) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { value: approverList, run: getApproverList } = useGetListApprover();
  const approverListOptions = useMemo(() => {
    return approverList?.data?.map((approver) => ({
      label: `${approver.forename} ${approver.surname}`,
      value: approver.id,
    }));
  }, [approverList]);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(defaultValues);
      getApproverList(payrollId, { page: 0, size: 999 });
    }
  }, [isOpen, payrollId]);

  const onFinish: FormProps['onFinish'] = (values) => {
    setIsSubmitting(true);
    onSubmit(values)
      .then(() => {
        toggle();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title="Assign Approver"
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: 'Cancel',
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: 'Submit',
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          label="Payroll Approver"
          name="approverIds"
          rules={[
            {
              required: true,
              message: 'Please enter',
            },
          ]}
        >
          <AppSelect
            options={approverListOptions ?? []}
            placeholder="Select Approver"
            mode="multiple"
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default RequestApprovalModal;
